module.exports = "https://cdn-assessment.mathletics.com/app/112/assets/images/5c349cdc89a076dc39e864bc6cd50059.svg";